import classNames from 'classnames';
import { FlexContainer, Txt } from 'components';
import styles from './OrdersSetup.module.scss';

/**
 * OrdersSetup
 *
 * @return {JSX.Element}
 */
const OrdersSetup = ({ className }) => {
  return (
    <FlexContainer
      className={classNames(
        styles.OrdersSetup,
        className,
        OrdersSetup.displayName
      )}
      column
      gap
    >
      <Txt bold>Standing orders have been setup 🎉</Txt>
      <Txt regular>
        Great! This tenancies standing orders are all setup. Please make sure
        you have the funds in your account before your rent is due. We'll send
        you a reminder one day before.
      </Txt>
    </FlexContainer>
  );
};

OrdersSetup.displayName = 'OrdersSetup';

export default OrdersSetup;
